import { createSlice } from '@reduxjs/toolkit';
import { ACH_PAYMENT_TAB } from '../checkout-form/checkout-constants';

const INIT_STATE = {
  stats: null,
  activePaymentMethodTab: ACH_PAYMENT_TAB,
  // TODO: Consider moving these to a reducer for its own flow
  licenseFeeInfo: null,
  newLicenseInfo: null,
  visitedFirstPageInFlow: false,
  paymentData: null,
};

export const sampleSlice = createSlice({
  name: 'app', // will be used for creating the action types. E.g.: "app/serverReturnedStats"
  initialState: INIT_STATE,
  reducers: {
    serverReturnedStats: (state, action) => {
      const { stats } = action.payload;
      state.stats = stats;
    },
    changePaymentMethodTab: (state, action) => {
      const { newTab } = action.payload;
      state.activePaymentMethodTab = newTab;
    },
    setLicenseFeeInfo: (state, action) => { // TODO: move to slice for license application flow
      const { licenseFeeInfo } = action.payload;
      state.licenseFeeInfo = licenseFeeInfo;
    },
    setNewLicenseInfo: (state, action) => {
      const { newLicenseInfo } = action.payload;
      state.newLicenseInfo = newLicenseInfo;
    },
    setVisitedFirstPageInFlow: (state, action) => {
      const { value } = action.payload;
      state.visitedFirstPageInFlow = value;
    },
  },
})

export const appActions = sampleSlice.actions;

export const appReducer = sampleSlice.reducer;
